import Image from "@components/core/Image";
import Link from "@components/core/Link";

function HeaderOnboarding() {
  return (
    <div className="border-bottom d-flex justify-content-center align-items-center onboarding-layout">
      <Link href="/home" className="link-dark">
        <Image src="logo" alt="logo" style={{ height: "24px" }} />
      </Link>
    </div>
  );
}

export default HeaderOnboarding;
